import { dropRight } from 'lodash';
import { compact } from './utils';

export { compact };

export function maxItems(list, count) {
  if (list.length > count) {
    return dropRight(list, list.length - count);
  }

  return list;
}

export function sortByKey(array, key, caseInsensitive = false) {
  return array.sort(function(a, b) {
    let x = a[key];
    let y = b[key];
    if (caseInsensitive) {
      x = typeof x === 'string' ? x.toLowerCase() : x;
      y = typeof y === 'string' ? y.toLowerCase() : y;
    }

    if (x < y) {
      return -1;
    } else if (x > y) {
      return 1;
    }

    return 0;
  });
}

export function sortByDate(array, identity, desc = false, id = 'id') {
  return array.sort((item1, item2) => {
    const lhs = Date.parse(item1[identity]);
    const rhs = Date.parse(item2[identity]);
    if (lhs < rhs) {
      return desc ? 1 : -1;
    } else if (lhs > rhs) {
      return desc ? -1 : 1;
    } else if (item1[id] && item2[id]) {
      // The dates are the same, which is rare, but possible so
      // check if there is an id and sort by that
      return desc ? item1[id] - item2[id] : item2[id] - item1[id];
    }

    return 0;
  });
}

export function appendUniquely(array, newItem, identifier) {
  const filteredArray = array.filter(
    (item) => identifier(item) !== identifier(newItem),
  );
  return [...filteredArray, newItem];
}

// Toggles the existence of the item in the array.
// If the item is not in the array then add it,
// otherwise remove it.
export function toggle(array, newItem, identifier) {
  const nextArray = [...array];
  const newItemIdentifier = identifier(newItem);
  const index = nextArray.findIndex(
    (existing) => identifier(existing) === newItemIdentifier,
  );

  if (index === -1) {
    nextArray.push(newItem);
  } else {
    nextArray.splice(index, 1);
  }

  return nextArray;
}

// Creates array [[key1, objectsForKey1], [key2, objectsForKey2], ...].
// - The order is preserved in the following sense:
//   If the first object with key1 occurs before any object with key2, then
//   the key1 pair will occur before the key2 pair in the output array.
// - Note that _.pairs(_.groupBy) above does NOT guarantee order preserving.
export function orderPreservingGroupBy(objects, keyFromObject) {
  const pairLookup = {}; // Map key -> pair [key, objects]
  const outputArray = [];

  objects.forEach((object) => {
    const key = keyFromObject(object);
    const existingPair = pairLookup[key];

    if (existingPair) {
      existingPair[1].push(object);
    } else {
      const newPair = [key, [object]];
      pairLookup[key] = newPair;
      outputArray.push(newPair);
    }
  });

  return outputArray;
}
